// #/services/registry/getService.ts

import { AWS_S3_BUCKET } from '#/config/constants';
import { s3 } from '#/services/s3';
import { OpenApiSchemaJson } from '#/types/registry';

export async function getService(
  serviceKey: string,
): Promise<OpenApiSchemaJson | null> {
  try {
    const s3ObjectKey = `openapiservices/${serviceKey}.json`;

    const serviceObject = await s3
      .getObject({ Bucket: AWS_S3_BUCKET, Key: s3ObjectKey })
      .promise();

    if (serviceObject == null || serviceObject?.Body == null) {
      return null;
    }

    const serviceBody =
      typeof serviceObject?.Body !== 'string'
        ? serviceObject?.Body.toString()
        : serviceObject?.Body;

    if (serviceBody == null || serviceBody === '') {
      return null;
    }

    return JSON.parse(serviceBody);
  } catch (error: any) {
    console.error(
      `Error fetching actions for service ${serviceKey}: ${error.message}`,
    );
    // throw new Error(`Error fetching actions for service ${serviceKey}: ${error.message}`);
    return null;
  }
}

export default getService;
